(function () {
  'use strict';

  var SEARCH_URL    = '/search/suggest.json';
  var DEBOUNCE_MS   = 200;
  var MAX_PRODUCTS  = 4;
  var MAX_SUGG      = 5;
  var MAX_SECTIONS  = 4;
  var RECENT_KEY    = 'cs_recent_searches';
  var MAX_RECENT    = 5;

  // ─── Smart prefix → compound term suggestions ────────────────────────────────
  // When Shopify's API doesn't surface the compound form (e.g. "face wash" for "face"),
  // these are injected as extra suggestions. They link to /search so they auto-adapt
  // to your inventory — no hardcoded SKUs or brand names here.
  var PREFIX_SUGGESTIONS = {
    'face':     ['face wash', 'face serum', 'face cream', 'face pack', 'face mask', 'face scrub', 'face toner', 'face oil'],
    'lip':      ['lip balm', 'lipstick', 'lip gloss', 'lip liner', 'lip tint', 'lip colour'],
    'eye':      ['eye cream', 'eye serum', 'eye shadow', 'eyeliner', 'eye liner', 'eye drops'],
    'sun':      ['sunscreen', 'sunblock', 'sun protection', 'sun cream'],
    'moist':    ['moisturiser', 'moisturizer', 'moisturising cream'],
    'hair':     ['hair serum', 'hair oil', 'hair colour', 'hair mask', 'hair conditioner', 'hair cream'],
    'body':     ['body wash', 'body lotion', 'body scrub', 'body oil', 'body butter'],
    'night':    ['night cream', 'night serum'],
    'day':      ['day cream', 'day moisturiser'],
    'bb':       ['bb cream'],
    'cc':       ['cc cream'],
    'foun':     ['foundation'],
    'conc':     ['concealer'],
    'blush':    ['blush', 'blusher'],
    'tone':     ['toner', 'face toner'],
    'serum':    ['serum', 'face serum', 'vitamin c serum', 'hair serum'],
    'vitam':    ['vitamin c serum', 'vitamin c cream', 'vitamin e oil'],
    'kajal':    ['kajal', 'kohl kajal'],
    'masca':    ['mascara'],
    'prime':    ['primer', 'face primer'],
    'micel':    ['micellar water'],
    'retinol':  ['retinol serum', 'retinol cream'],
    'niacinam': ['niacinamide serum', 'niacinamide cream'],
    'aha':      ['aha bha toner', 'aha serum'],
    'blot':     ['blotting paper', 'blotting sheets'],
  };

  // ─── Beauty synonym map (client-side, fallback for common compound words) ──
  // For full synonym support also use Shopify → Apps → Search & Discovery → Synonyms
  var SYNONYMS = {
    'facewash':        'face wash',
    'facepack':        'face pack',
    'facemask':        'face mask',
    'faceoil':         'face oil',
    'facecream':       'face cream',
    'bodywash':        'body wash',
    'bodylotion':      'body lotion',
    'bodyoil':         'body oil',
    'bodyscrub':       'body scrub',
    'bbcream':         'bb cream',
    'cccream':         'cc cream',
    'eyecream':        'eye cream',
    'eyeshadow':       'eye shadow',
    'nightcream':      'night cream',
    'daycream':        'day cream',
    'handcream':       'hand cream',
    'lipbalm':         'lip balm',
    'lipgloss':        'lip gloss',
    'lipcolor':        'lipstick',
    'lipcolour':       'lipstick',
    'lip color':       'lipstick',
    'lip colour':      'lipstick',
    'hairserum':       'hair serum',
    'hairoil':         'hair oil',
    'haircolor':       'hair colour',
    'haircolour':      'hair colour',
    'hair color':      'hair colour',
    'hairspray':       'hair spray',
    'sun screen':      'sunscreen',
    'sunscream':       'sunscreen',
    'moisturizer':     'moisturiser',
    'moisturisor':     'moisturiser',
    'micellarwater':   'micellar water',
    'tzone':           't-zone',
    't zone':          't-zone',
  };

  function normalizeQuery(q) {
    var lower = q.toLowerCase().trim();
    return SYNONYMS[lower] || q.trim();
  }

  // ─── Recent searches (localStorage) ────────────────────────────────────────
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').slice(0, MAX_RECENT); }
    catch (e) { return []; }
  }
  function saveRecent(term) {
    if (!term || term.length < 2) return;
    var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT))); } catch (e) {}
  }
  function removeRecent(term) {
    var list = getRecent().filter(function (t) { return t !== term; });
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }

  // ─── DOM references ─────────────────────────────────────────────────────────
  var $ = {
    bar: null, input: null, clear: null,
    drop: null, overlay: null,
    trending: null, recentEl: null, body: null,
    suggestions: null, categories: null, products: null,
    viewall: null, empty: null, toggle: null,
  };
  var abortCtrl = null;
  var debounceTimer = null;

  // ─── Init ────────────────────────────────────────────────────────────────────
  function init() {
    $.bar = document.getElementById('cs-msearch');
    if (!$.bar) return;
    if (window.matchMedia('(min-width: 768px)').matches) return;

    $.toggle      = document.getElementById('cs-msearch-toggle');
    $.input       = document.getElementById('cs-msearch-input');
    $.clear       = document.getElementById('cs-msearch-clear');
    $.drop        = document.getElementById('cs-msearch-drop');
    $.overlay     = document.getElementById('cs-msearch-overlay');
    $.trending    = document.getElementById('cs-msearch-trending');
    $.recentEl    = document.getElementById('cs-msearch-recent');
    $.body        = document.getElementById('cs-msearch-body');
    $.suggestions = document.getElementById('cs-msearch-suggestions');
    $.categories  = document.getElementById('cs-msearch-categories');
    $.products    = document.getElementById('cs-msearch-products');
    $.viewall     = document.getElementById('cs-msearch-viewall');
    $.empty       = document.getElementById('cs-msearch-empty');

    if (!$.input || !$.drop) return;

    // Portal drop + overlay to <body> — escapes xo-sticky stacking context
    document.body.appendChild($.drop);
    document.body.appendChild($.overlay);

    bindEvents();
  }

  // ─── Events ──────────────────────────────────────────────────────────────────
  function bindEvents() {
    if ($.toggle) $.toggle.addEventListener('click', onToggle);
    $.input.addEventListener('focus', onFocus);
    $.input.addEventListener('input', onInput);
    $.clear.addEventListener('click', onClear);
    $.overlay.addEventListener('click', close);

    // Trending chips
    $.trending.querySelectorAll('[data-cs-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var term = chip.dataset.csChip;
        $.input.value = term;
        $.clear.hidden = false;
        saveRecent(term);
        doFetch(normalizeQuery(term));
        $.input.focus();
      });
    });

    // Recent searches — event delegation (items are dynamic)
    if ($.recentEl) {
      $.recentEl.addEventListener('click', function (e) {
        var del  = e.target.closest('[data-cs-del]');
        var item = e.target.closest('[data-cs-recent]');
        if (del) {
          e.preventDefault(); e.stopPropagation();
          removeRecent(del.dataset.csDel);
          renderRecent();
          return;
        }
        if (item) {
          var term = item.dataset.csRecent;
          $.input.value = term;
          $.clear.hidden = false;
          saveRecent(term);
          doFetch(normalizeQuery(term));
        }
      });
    }

    // Save recent on form submit
    var form = $.bar.querySelector('.cs-msearch__form');
    if (form) {
      form.addEventListener('submit', function () {
        var q = $.input.value.trim();
        if (q) {
          saveRecent(q);
          $.input.value = normalizeQuery(q);
        }
      });
    }

    // Save recent when clicking a suggestion link
    document.addEventListener('click', function (e) {
      var sugg = e.target.closest('.cs-msearch-sugg[data-term]');
      if (sugg) saveRecent(sugg.dataset.term);
      var prod = e.target.closest('.cs-msearch-prod[data-term]');
      if (prod) saveRecent(prod.dataset.term);
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', function () { if (!$.drop.hidden) positionDrop(); }, { passive: true });
    // visualViewport fires when Chrome toolbar shows/hides or keyboard opens/closes
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        if (!$.drop.hidden) positionDrop();
      });
    }
  }

  // ─── Toggle bar open/close ───────────────────────────────────────────────────
  function onToggle() {
    if ($.bar.classList.contains('cs-msearch--open')) {
      close();
    } else {
      $.bar.classList.add('cs-msearch--open');
      $.toggle.setAttribute('aria-expanded', 'true');
      setTimeout(function () { $.input.focus(); }, 50);
    }
  }

  // ─── Focus / input / clear ───────────────────────────────────────────────────
  function onFocus() {
    positionDrop();
    openDrop();
    if (!$.input.value.trim()) showTrending();
  }

  function onInput() {
    clearTimeout(debounceTimer);
    var q = $.input.value.trim();
    $.clear.hidden = (q.length === 0);
    if (q.length >= 2) {
      debounceTimer = setTimeout(function () { doFetch(normalizeQuery(q)); }, DEBOUNCE_MS);
    } else if (q.length === 0) {
      showTrending();
    }
  }

  function onClear() {
    $.input.value = '';
    $.clear.hidden = true;
    showTrending();
    $.input.focus();
  }

  // ─── Positioning / open / close ──────────────────────────────────────────────
  function positionDrop() {
    var rect      = $.bar.getBoundingClientRect();
    var barBottom = Math.round(rect.bottom);
    // window.visualViewport.height = true visible area, already excludes Chrome's
    // bottom toolbar (back/forward bar) and on-screen keyboard.
    // Falls back to window.innerHeight for older browsers.
    var visH      = (window.visualViewport ? window.visualViewport.height : window.innerHeight);
    var available = Math.max(200, visH - barBottom - 8); // 8px breathing room
    $.drop.style.top       = barBottom + 'px';
    $.drop.style.maxHeight = available + 'px';
    // Overlay starts BELOW the bar — prevents it from dimming the input field
    $.overlay.style.top    = barBottom + 'px';
  }

  function openDrop() {
    $.drop.hidden    = false;
    $.overlay.hidden = false;
    $.input.setAttribute('aria-expanded', 'true');
    // Prevent background page from scrolling while search is open
    document.body.style.overflow = 'hidden';
  }

  function close() {
    $.bar.classList.remove('cs-msearch--open');
    if ($.toggle) $.toggle.setAttribute('aria-expanded', 'false');
    $.drop.hidden    = true;
    $.overlay.hidden = true;
    $.input.setAttribute('aria-expanded', 'false');
    $.input.blur();
    // Restore background scroll
    document.body.style.overflow = '';
    if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }
    clearTimeout(debounceTimer);
  }

  // ─── State switches ───────────────────────────────────────────────────────────
  function showTrending() {
    renderRecent();
    $.trending.hidden = false;
    $.body.hidden     = true;
    $.empty.hidden    = true;
  }

  function showBody() {
    $.trending.hidden = true;
    $.body.hidden     = false;
    $.empty.hidden    = true;
  }

  function showEmpty() {
    $.trending.hidden = true;
    $.body.hidden     = true;
    $.empty.hidden    = false;
  }

  // ─── Recent searches rendering ────────────────────────────────────────────────
  function renderRecent() {
    if (!$.recentEl) return;
    var list = getRecent();
    if (!list.length) { $.recentEl.innerHTML = ''; $.recentEl.hidden = true; return; }

    $.recentEl.hidden = false;
    $.recentEl.innerHTML =
      '<p class="cs-msearch-drop__section-label">' + SVG_CLOCK + ' Recent</p>'
      + list.map(function (term) {
          return '<div class="cs-msearch-recent-row">'
            + '<a href="/search?q=' + encodeURIComponent(term) + '&type=product"'
            + '   class="cs-msearch-sugg" data-cs-recent="' + escAttr(term) + '">'
            + '  <span class="cs-msearch-sugg__ico">' + SVG_CLOCK + '</span>'
            + '  <span class="cs-msearch-sugg__text">' + esc(term) + '</span>'
            + '</a>'
            + '<button type="button" class="cs-msearch-recent-del" data-cs-del="' + escAttr(term) + '" aria-label="Remove">'
            + SVG_CLOSE + '</button>'
            + '</div>';
        }).join('');
  }

  // ─── Fetch ────────────────────────────────────────────────────────────────────
  async function doFetch(q) {
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    var params = new URLSearchParams({
      q: q,
      'resources[type]': 'product,collection,query',
      'resources[limit]': '8',
      'resources[options][unavailable_products]': 'last',
      // Include vendor field so brand searches (e.g. "vlcc") return products correctly
      'resources[options][fields]': 'title,product_type,variants.title,vendor,tag',
    });

    try {
      var res  = await fetch(SEARCH_URL + '?' + params.toString(), { signal: abortCtrl.signal });
      var data = await res.json();
      abortCtrl = null;
      renderResults(q, data.resources.results);
    } catch (e) {
      if (e.name !== 'AbortError') showEmpty();
    }
  }

  // ─── Render results ────────────────────────────────────────────────────────────
  function renderResults(q, results) {
    var queries     = (results && results.queries)     || [];
    var products    = (results && results.products)    || [];
    var collections = (results && results.collections) || [];

    if (!queries.length && !products.length && !collections.length) {
      showEmpty(); return;
    }

    renderSuggestions(queries, q);
    renderBrandsAndCategories(collections, products, q);
    renderProducts(products, q);
    showBody();
  }

  // ─── SVG icons ────────────────────────────────────────────────────────────────
  var SVG_SEARCH = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
  var SVG_FOLDER = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>';
  var SVG_TAG    = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
  var SVG_CLOCK  = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
  var SVG_CLOSE  = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var SVG_ARROW  = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

  // ─── Smart suggestion helpers ─────────────────────────────────────────────────

  // Returns prefix-expanded compound suggestions for a query
  function getPrefixSuggestions(q) {
    var lower = q.toLowerCase().trim();
    if (lower.length < 2) return [];
    var results = [];
    var added   = {};
    Object.keys(PREFIX_SUGGESTIONS).forEach(function (key) {
      if (key.startsWith(lower) || lower.startsWith(key)) {
        PREFIX_SUGGESTIONS[key].forEach(function (s) {
          var k = s.toLowerCase();
          if (!added[k]) { added[k] = true; results.push(s); }
        });
      }
    });
    return results;
  }

  // Bolds the matched portion inside a suggestion string
  function highlightQuery(text, q) {
    var tLow = text.toLowerCase();
    var qLow = q.toLowerCase().trim();
    var idx  = tLow.indexOf(qLow);
    if (idx === -1 || !qLow) return esc(text);
    return esc(text.slice(0, idx))
      + '<mark>' + esc(text.slice(idx, idx + qLow.length)) + '</mark>'
      + esc(text.slice(idx + qLow.length));
  }

  // Brand chip relevance: only show a brand chip when the query contains (or
  // is contained by) the brand name — suppresses noise for generic terms like
  // "face" or "serum" that incidentally return products from any brand.
  function isBrandQueryRelevant(vendor, q) {
    if (!q || q.length < 2) return false;
    var v     = vendor.toLowerCase().replace(/[.\-_]/g, ' ').trim();
    var query = q.toLowerCase().trim();
    if (query.includes(v) || v.includes(query)) return true;
    // Word-level partial match (e.g. "dr r" → "Dr.Rashel")
    var qWords = query.split(/\s+/).filter(function (w) { return w.length >= 2; });
    var vWords = v.split(/\s+/).filter(function   (w) { return w.length >= 2; });
    return qWords.some(function (qw) {
      return vWords.some(function (vw) {
        return vw.startsWith(qw) || qw.startsWith(vw);
      });
    });
  }

  // ─── Suggestions ──────────────────────────────────────────────────────────────
  function renderSuggestions(queries, q) {
    // Normalise API items
    var apiItems = queries.slice(0, MAX_SUGG).map(function (item) {
      return { text: item.text, html: item.styled_text || esc(item.text) };
    });

    // Prefix-expanded extras (only those not already returned by API)
    var apiTexts = apiItems.map(function (s) { return s.text.toLowerCase(); });
    var extras   = getPrefixSuggestions(q)
      .filter(function (s) { return apiTexts.indexOf(s.toLowerCase()) === -1; })
      .map(function   (s) { return { text: s, html: highlightQuery(s, q) }; });

    // API results first, fill remaining slots with prefix extras
    var items = apiItems.concat(extras).slice(0, MAX_SUGG);

    // Always show at least the raw query
    if (!items.length) items = [{ text: q, html: esc(q) }];

    $.suggestions.innerHTML = items.map(function (item) {
      var href = '/search?q=' + encodeURIComponent(item.text) + '&type=product';
      return '<a href="' + href + '" class="cs-msearch-sugg" data-term="' + escAttr(item.text) + '">'
        + '<span class="cs-msearch-sugg__ico">' + SVG_SEARCH + '</span>'
        + '<span class="cs-msearch-sugg__text">' + item.html + '</span>'
        + '</a>';
    }).join('');
  }

  // ─── Brands + Categories (smart split) ────────────────────────────────────────
  // Strategy:
  //   • Brands   = unique vendor names found directly in the returned products
  //               (no dependency on a matching collection existing)
  //   • Categories = API collections that are NOT a vendor name
  function renderBrandsAndCategories(collections, products, q) {
    // 1. Unique vendors from returned products — filtered to query-relevant brands only
    //    (suppresses noise like "Dr.Rashel" showing for generic "face" searches)
    var vendors = [];
    var vendorSeen = {};
    products.forEach(function (p) {
      var key = (p.vendor || '').toLowerCase().trim();
      if (key && !vendorSeen[key] && isBrandQueryRelevant(p.vendor, q)) {
        vendorSeen[key] = true;
        vendors.push(p.vendor.trim());
      }
    });

    // 2. Try to find a matching collection URL for each vendor (for click destination)
    var vendorUrlMap = {};
    collections.forEach(function (col) {
      var t = col.title.toLowerCase().trim();
      if (vendorSeen[t]) vendorUrlMap[t] = col.url;
    });

    // 3. Categories = collections that don't match any vendor
    var cats = collections.filter(function (col) {
      return !vendorSeen[col.title.toLowerCase().trim()];
    });

    var html = '';

    if (vendors.length) {
      html += '<p class="cs-msearch-drop__section-label">' + SVG_TAG + ' Brands</p>'
        + '<div class="cs-msearch-cat-chips">'
        + vendors.slice(0, MAX_SECTIONS).map(function (vendor) {
            // Prefer the collection URL; fallback to a brand search
            var url = vendorUrlMap[vendor.toLowerCase()]
              || '/search?q=' + encodeURIComponent(vendor) + '&type=product';
            return '<a href="' + url + '" class="cs-msearch-cat-chip cs-msearch-cat-chip--brand">' + esc(vendor) + '</a>';
          }).join('')
        + '</div>';
    }

    if (cats.length) {
      html += '<p class="cs-msearch-drop__section-label' + (vendors.length ? ' cs-msearch-lbl--mt' : '') + '">'
        + SVG_FOLDER + ' Categories</p>'
        + '<div class="cs-msearch-cat-chips">'
        + cats.slice(0, MAX_SECTIONS).map(function (c) {
            return '<a href="' + c.url + '" class="cs-msearch-cat-chip">' + esc(c.title) + '</a>';
          }).join('')
        + '</div>';
    }

    $.categories.innerHTML = html;
  }

  // ─── Products ─────────────────────────────────────────────────────────────────
  function renderProducts(products, q) {
    var sym = (typeof window.currency_symbol !== 'undefined' && window.currency_symbol) ? window.currency_symbol : '₹';

    if (!products.length) {
      $.products.innerHTML = '<p class="cs-msearch-noprod">No products found</p>';
      renderViewAll(q);
      return;
    }

    $.products.innerHTML = products.slice(0, MAX_PRODUCTS).map(function (p) {
      var rawImg = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
      var imgSrc = rawImg ? rawImg + (rawImg.indexOf('?') !== -1 ? '&' : '?') + 'width=300' : '';
      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + escAttr(p.title) + '" loading="lazy" width="150" height="150">'
        : '<div class="cs-msearch-prod__img-ph"></div>';

      return '<a href="' + p.url + '" class="cs-msearch-prod" data-term="' + escAttr(q) + '">'
        + '<div class="cs-msearch-prod__img">' + imgHtml + '</div>'
        + '<div class="cs-msearch-prod__info">'
        + '<div class="cs-msearch-prod__title">' + esc(p.title) + '</div>'
        + buildPriceHtml(p, sym)
        + '</div>'
        + '</a>';
    }).join('');

    renderViewAll(q);
  }

  // Price: show compare_at_price strikethrough + % OFF badge if discounted
  // Shopify predictive search returns prices in the store currency (rupees for INR),
  // NOT in paise — so we do NOT divide by 100.
  // NOTE: The API does NOT return "compare_at_price" — it returns
  // "compare_at_price_max" and "compare_at_price_min" instead.
  function buildPriceHtml(p, sym) {
    var price     = parseFloat(p.price || 0);
    // Use the maximum compare_at_price across variants (shows best deal)
    var compareAt = parseFloat(p.compare_at_price_max || p.compare_at_price_min || p.compare_at_price || 0);
    var hasDeal   = compareAt > price && price > 0;

    if (!price) return '';

    var fPrice   = sym + Math.round(price).toLocaleString('en-IN');
    var fCompare = hasDeal ? sym + Math.round(compareAt).toLocaleString('en-IN') : '';
    var pct      = hasDeal ? Math.round((1 - price / compareAt) * 100) : 0;

    if (hasDeal) {
      return '<div class="cs-msearch-prod__prices">'
        + '<span class="cs-msearch-prod__price">' + fPrice + '</span>'
        + '<span class="cs-msearch-prod__compare">' + fCompare + '</span>'
        + '<span class="cs-msearch-prod__badge">' + pct + '% OFF</span>'
        + '</div>';
    }
    return '<div class="cs-msearch-prod__prices">'
      + '<span class="cs-msearch-prod__price">' + fPrice + '</span>'
      + '</div>';
  }

  // "See all results" link
  function renderViewAll(q) {
    if (!$.viewall) return;
    var href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    $.viewall.innerHTML = '<a href="' + href + '" class="cs-msearch-viewall" data-term="' + escAttr(q) + '">'
      + 'See all results for &ldquo;' + esc(q) + '&rdquo; ' + SVG_ARROW
      + '</a>';
  }

  // ─── Helpers ──────────────────────────────────────────────────────────────────
  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function escAttr(s) {
    return String(s || '').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
